import React from 'react';
import { componentService } from 'js/services/component.service';

export const ResponsibleGamingSingleBetLimit = React.lazy(() => import(/* webpackChunkName: "responsible-gaming-single-bet-limit" */ './ResponsibleGamingSingleBetLimit'));

componentService.registerPageComponents({ 'responsible-gaming-single-bet-limit': ResponsibleGamingSingleBetLimit });
